<template>
  <v-container id="navigation" fluid pa-0>
    <div id="bottom-menu-background" :class="{open: isOpen}">
      <transition name="more-trans" mode="out-in">
        <v-btn
          v-if="!isOpen"
          id="upper-nav-more-button"
          flat
          color="#AE250A"
          @click="isOpen = true"
        >
          MORE
          <v-icon medium dark>arrow_drop_up</v-icon>
        </v-btn>
      </transition>
      <transition name="more-trans">
        <v-btn
          v-if="isOpen"
          id="upper-nav-more-button"
          flat
          color="#AE250A"
          @click="isOpen = false"
        >
          LESS
          <v-icon medium dark>arrow_drop_down</v-icon>
        </v-btn>
      </transition>

      <v-layout justify-center align-center row no-wrap id="bottom-nav-upper" color="transparent">
        <v-flex xs4 class="nav-button" px-2 @click="setActiveAndNavigate('suspects')">
          <transition name="fade">
            <div key="suspect-active" v-if="active === 'suspects'">
              <v-badge :value="activeUnreadClues > 0" overlap color="#AE250A">
                <span id="badge" slot="badge">{{activeUnreadClues}}</span>
                <img :src="suspectsNavActive">
              </v-badge>
            </div>
          </transition>
          <div key="suspect-inactive" class="inactive suspects-nav" v-if="active !== 'suspects'">
            <v-badge :value="activeUnreadClues > 0" overlap color="#AE250A">
              <span id="badge" slot="badge">{{activeUnreadClues}}</span>
              <img :src="suspectsNavInactive">
            </v-badge>
          </div>
        </v-flex>

        <v-flex xs4 class="nav-button tour-button" px-2 @click="setActiveAndNavigate('tour')">
          <transition name="fade">
            <div v-if="active === 'tour'">
              <img :src="tourNavActive">
            </div>
          </transition>
          <div class="inactive tour-nav" v-if="active !== 'tour'">
            <img :src="tourNavInactive">
          </div>
        </v-flex>

        <v-flex xs4 class="nav-button" px-2 @click="navHelpDialog = true">
          <transition name="fade">
            <div v-if="active === 'help'">
              <img :src="helpNavActive">
            </div>
          </transition>
          <div class="inactive help-nav" v-if="active !== 'help'">
            <img :src="helpNavInactive">
          </div>
        </v-flex>
      </v-layout>
      <v-bottom-nav
        class="bebas"
        id="bottom-nav-lower"
        :active.sync="activeBottom"
        height="40"
        value="yes"
        color="transparent"
      >
        <v-btn color="black" flat value="faqs" @click="openFAQ">
          <span class="subheading">FAQs</span>
        </v-btn>
        <v-btn color="black" flat value="restart" @click.native.stop="openTSDialog">
          <span class="subheading">Trouble-Shooting</span>
        </v-btn>

        <v-btn color="black" flat value="credits" @click="openCredits">
          <span class="subheading">Credits</span>
        </v-btn>

        <v-btn color="#AE250A" flat value="logout" @click="logout">
          <span class="subheading">Logout</span>
        </v-btn>
      </v-bottom-nav>
    </div>
    <v-dialog
      id="nav-help-dialog"
      content-class="fdi-help-modal"
      class="border-radius-15"
      persistent
      max-width="280"
      v-model="navHelpDialog"
    >
      <v-card color="rgba(0, 0, 0, 0.9)" class="border-radius-15 modal-class">
        <v-container pa-0 text-xs-center fill-height>
          <v-flex d-flex>
            <v-flex align-start>
              <v-flex d-flex align-center justify-center>
                <v-flex xs4>
                  <v-img :src="liveChatIcon"></v-img>
                </v-flex>
              </v-flex>
              <v-flex d-flex align-center justify-center mt-3>
                <v-flex xs10>
                  <p class="text-xs-center white--text fs-16">
                    Click
                    <span class="fdi-red--text">live chat</span> to open up your messaging app where you can receive live assistance from your Fooddoneit Director
                  </p>
                </v-flex>
              </v-flex>
              <v-flex d-flex align-center justify-center mb-3>
                <v-flex xs6 d-flex>
                  <v-btn
                    class="button-border-beige"
                    flat
                    block
                    color="#D6B682"
                    @click.native="openMessagingApp"
                  >live chat</v-btn>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-container>

        <v-card-actions class="modal-actions">
          <v-spacer></v-spacer>
          <v-btn flat @click.native="goBack">
            <v-img :src="backButton"/>
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn flat/>
          <v-spacer></v-spacer>
          <v-btn flat/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import suspectsNavActive from "@/assets/suspects2.png";
import tourNavInactive from "@/assets/tour1.png";
import tourNavActive from "@/assets/tour2.png";
import suspectsNavInactive from "@/assets/suspects1.png";
import helpNavInactive from "@/assets/help1.png";
import helpNavActive from "@/assets/help2.png";
import liveChatIcon from "@/assets/help_lrg_icon-min.png";
import continueButton from "@/assets/buttons/continue.png";
import backButton from "@/assets/directions/back_button.png";
import refreshButton from "@/assets/buttons/refresh_button-min.png";

export default {
  name: "navigation",
  props: {
    currentTourPlace: String
  },
  data() {
    return {
      active: "tour",
      activeBtn: 1,
      navHelpDialog: false,
      showNavShelf: false,
      showNav: true,
      dialog: false,
      show: false,
      isOpen: false,
      activeBottom: "logout",
      loadingImages: true,
      suspectsNavInactive,
      suspectsNavActive,
      helpNavInactive,
      helpNavActive,
      tourNavInactive,
      tourNavActive,
      liveChatIcon,
      continueButton,
      backButton,
      refreshButton,
      tsDialog: false
    };
  },
  created() {},
  watch: {
    $route(to, from) {
      this.active = to.path.substring(1);
    }
  },
  methods: {
    goBack() {
      this.navHelpDialog = false;
    },
    openMessagingApp() {
      window.open("sms:16314381288‬", "_self");
    },

    navigationClick: function(event, i) {
      //console.log(i)
    },
    logout() {
      this.$router.push("/auth/signout");
    },
    setActiveAndNavigate(name) {
      var pushMax = this.active === name;
      this.active = name;
      if (pushMax && name === "tour") {
        this.$store.dispatch("navigateToMaxPosition");
      } else if (name === "tour") {
        this.$router.push("tour");
      } else {
        this.$router.push(`/${name}`);
      }
    },
    openFAQ() {
      this.$store.dispatch("openFAQS");
    },
    openTSDialog() {
      this.$store.dispatch("openTSDialog");
    },
    openCredits() {
      this.$store.dispatch("openCredits");
    },

    closeDialog() {
      this.show = false;
      this.dialog = false;
    },
    openDialog() {
      this.isOpen = true;
    }
  },
  computed: {
    currentUrl() {
      return this.$router.history.current.path.substr(1);
    },
    currentPlace() {
      return this.$store.getters.currentTourPlacement;
    },
    dialogActive() {},
    activeUnreadClues() {
      return this.$store.getters.totalUnreadActiveClues;
    }
  }
};
</script>

<style>
.fdi-red--text {
  color: #ae250a;
}

#navigation {
  width: 100%;
  background: transparent;
  position: relative;
  bottom: 0;
  font-family: "BebasNeue-Regular";
}

#badge {
  font-family: "BebasNeue-Regular";
  display: block;
}

#navigation .v-bottom-nav .v-btn {
  padding: 8px 0px 10px;
}

.nav-button {
  height: 100%;
}

.nav-button img {
  max-width: 75px;
  max-height: 100%;
  display: block;
}

.nav-button .inactive {
  margin-top: 14px;
}

.nav-button .inactive.suspects-nav img {
  max-width: 67%;
  max-height: 100%;
  margin: auto auto;
  padding-top: 2px;
}

.nav-button .inactive.tour-nav img {
  max-width: 33%;
  max-height: 100%;
  margin: auto auto;
  padding-top: 3px;
}

.nav-button .inactive.help-nav img {
  max-width: 40%;
  max-height: 100%;
  margin: auto auto;
  padding-top: 4px;
}

.nav-button .inactive span {
  display: block;
  margin: auto auto;
  text-align: center;
  font-size: 13px;
  line-height: 1.2;
  letter-spacing: -1px;
}

#bottom-nav-upper {
  position: absolute;
  bottom: 45px;
  font-family: "1942";
  height: 90px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#bottom-nav-upper .nav-button {
  position: relative;
  top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tour-button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

#bottom-nav-lower {
  position: absolute;
  bottom: 0px;
  font-family: "1942";
  font-weight: "bold";
}

#navigation .v-bottom-nav {
  box-shadow: none;
}

#bottom-menu-background.open {
  transition: bottom 700ms;
  bottom: 0px;
}

#bottom-menu-background {
  background-image: url("../assets/folder_expand.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 170px;
  position: absolute;
  transition: bottom 500ms;
  bottom: -45px;
}

#bottom-menu-buttons {
  position: relative;
  bottom: 0px;
}

#bottom-shelf {
  width: 100%;
  height: 40px;
  background-color: #e9d1b0;
  position: relative;
}

.fade-enter-active {
  transition: all 0.75s;
}

.fade-enter {
  transform: scale(2);
}

.fade-enter-to {
  transform: scale(1);
}

.more-trans-enter-active {
  transition: all 1000ms;
}

.more-trans-leave-active {
  transition: all 0ms;
}

.more-trans-enter {
  opacity: 0;
}

.more-trans-leave {
  opacity: 0.05;
}

.more-trans-enter-to {
  opacity: 1;
}

.more-trans-leave-to {
  opacity: 0;
}

.slide-in-bottom {
  -webkit-animation: slide-in-bottom 0.5s ease-in both;
  animation: slide-in-bottom 0.5s ease-in both;
}

.slide-out-bottom {
  -webkit-animation: slide-in-bottom 0.5s ease-out reverse both;
  animation: slide-in-bottom 0.5s ease-out reverse both;
}

@-webkit-keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(250px);
    transform: translateY(250px);
    opacity: 1;
    z-index: 50;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
    z-index: 50;
  }
}

@keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(250px);
    transform: translateY(250px);
    opacity: 1;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

@-webkit-keyframes slide-out-bottom {
  0% {
    -webkit-transform: translateY(1000px);
    transform: translateY(1000px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-out-bottom {
  0% {
    -webkit-transform: translateY(1000px);
    transform: translateY(1000px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
